// Single source of truth for the community Discord invite.
export const DISCORD_INVITE_URL = 'https://discord.gg/EpheNCFjN9';
